export default __webpack_public_path__ + "static/media/operation-user.66f0798c.docx";